import { TitleCasePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, input, output, signal, WritableSignal } from '@angular/core';
import { form, FormField } from '@angular/forms/signals';
import { MatListModule } from '@angular/material/list';
import { AgentProfileFilterKey, FRENCH_REGIONS, ZoudashUtils } from '@workspace/data-types';
import {
  AbstractSignalFormComponent,
  DataHeaderFilter,
  FilterChangedDetection,
  FilterRecord,
} from '@workspace/ng-aura';
import { AgentColumnKey } from '../abstract-agents-data-table.component';

export interface AgentFilterModel {
  type: string | string[] | null;
  region: string | string[] | null;
}

@Component({
  selector: 'etxe-agents-data-table-filter',
  templateUrl: './agents-data-table-filter.component.html',
  imports: [FormField, MatListModule, TitleCasePipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AgentsDataTableFilterComponent extends AbstractSignalFormComponent<
  Partial<Record<AgentColumnKey, string | string[]>>,
  AgentFilterModel
> {
  filterChanged = output<FilterChangedDetection>();
  currentFilterView = input<string | null>(null);
  filters = input.required<DataHeaderFilter<AgentColumnKey>[]>();

  agentProfileFilterKey = AgentProfileFilterKey;
  agentTypeValues: string[] = ['titulaire', 'mandataire'];
  availableRegions = FRENCH_REGIONS;

  override model: WritableSignal<AgentFilterModel> = signal<AgentFilterModel>({
    type: null,
    region: null,
  });

  override formTree = form(this.model);

  override emitDto(newDto: Partial<Record<AgentColumnKey, string | string[]>>): void {
    this.filterChanged.emit({
      filter: newDto as FilterRecord,
      changed: !ZoudashUtils.isEqual(newDto, this.ogValue),
    });
  }

  protected override buildModelFromDto(
    dto: Partial<Record<AgentColumnKey, string | string[]>>,
  ): AgentFilterModel {
    return {
      type: dto?.['type'] ?? null,
      region: dto?.['region'] ?? null,
    };
  }

  protected override buildDtoFromModel(
    model: AgentFilterModel,
  ): Partial<Record<AgentColumnKey, string | string[]>> {
    const dto: Partial<Record<string, string | string[]>> = {
      [AgentProfileFilterKey.Type]: model.type ?? undefined,
      [AgentProfileFilterKey.Region]: model.region ?? undefined,
    };
    return Object.fromEntries(Object.entries(dto).filter(([, v]) => v != null)) as Partial<
      Record<AgentColumnKey, string | string[]>
    >;
  }
}
